import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {HelpModule} from "../../components/help/help.module";
import {PruefungStandortPage} from "./pruefung-standort";

@NgModule({
  declarations: [
    PruefungStandortPage,
  ],
  entryComponents: [
    PruefungStandortPage,
  ],
  imports: [
    IonicPageModule.forChild(PruefungStandortPage),
    HelpModule
  ]
})
export class PruefungStandortModule {}



// WEBPACK FOOTER //
// ./src/pages/pruefung-standort/pruefung-standort.module.ts